<!--
 * @Description: 
 * @Author: 李方强
 * @Date: 2019-07-25 16:12:31
 * @LastEditTime: 2021-09-08 17:50:36
 * @LastEditors: lkz
 -->
<template>
  <div id="totop">
    <div class="totop_left">
      <label @click="setflg">
        <img v-if="flg" src="./slideLeft.png" alt="" />
        <img v-else src="./sildeRight.png" alt="" />
      </label>
      <span>{{ this.$route.meta.title }}</span>
    </div>
    <div class="totop_mid" v-if="showEmpIndex">
      <table width="300px">
        <tr style="color: #808080;"><th>应答量</th><th>满意度</th><th>首响</th><th>均响</th><th>本队列排队</th></tr>
        <tr style="text-align: center; font-size: 14px;">
          <td>{{empTarget.responseCount}}</td>
          <td>{{empTarget.satisfaction}}%</td>
          <td>{{empTarget.firstResponseTime}}s</td>
          <td>{{empTarget.allRings}}s</td>
          <td>{{empTarget.queueUpCnt}}人</td>
        </tr>
      </table>
    </div>
    
    <div class="totop_right">
      <div class="totop_menus" v-show="showline">
        <span id="panelProp">
          <el-cascader
            :show-all-levels="false"
            v-model="cascaderValue"
            :options="startTypeEnum"
            :props="cascaderProps"
            @change="handleCascader"
          >
          </el-cascader>
        </span>
        <!-- OA申请状态展示 -->
        <span class="oa_state" v-show="isOaStartName"
          >{{ oaStateName }}<i @click="getOaClose" v-show="isOaClose" class="el-icon-circle-close"></i
        ></span>
        <span>通讯：</span>
        <span v-bind:style="{ color: wsConnetState ? '#FF0000' : '#009933', marginRight: '28px' }">
          {{ wsConnetState ? '已断开' : '正常' }}
          <span v-if="wsConnetState == 1" style="color:#6b6b6b;margin-left:8px;">
            {{ '重连中...' }}
          </span>
          <span v-if="wsConnetState == 2" style="color:#189eff;margin-left:8px;" @click="reload">
            {{ '刷新' }}
          </span>
        </span>
      </div>
      <div class="totop_menus">
        <el-dropdown trigger="click" v-if="showButton">
          <span class="el-dropdown-link"> 快捷导航<i class="el-icon-arrow-down el-icon--right"></i> </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item><span @click="getwork">工作台</span></el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-popover
          placement="bottom"
          width="400"
          title="通知"
          trigger="click"
          popper-class="totop-message-class">
          <message-box v-model="messageTotal"></message-box>
          <el-badge :value="messageTotal" :hidden="messageTotal === 0" slot="reference" class="message-badge">
            <span>消息</span>
          </el-badge>
        </el-popover>
      </div>
      <!-- <label class="toptop_name0">
        <el-dropdown trigger="click">
          <span class="el-dropdown-link">{{ empIds.userName }}<i v-if="empIds.userName" class="el-icon-arrow-down el-icon--right"></i> </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-if='yunkefu'><span @click="getPassWord">修改密码</span></el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </label> -->
    </div>
    <!-- OA审批弹窗 -->
    <el-dialog title="提示" :visible.sync="ApprovalVisible" :modal="false" top="30vh" width="400px" center>
      <span>申请切换到{{ stateName }}状态需要OA审批，确定吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="approvalCancel">取 消</el-button>
        <el-button type="primary" @click="approvalSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex'
import MessageBox from './MessageBox'
import * as http from './work.service'

export default {
  name: 'totop',
  components: {
    MessageBox
  },
  props: {
    slideflg: {
      type: Boolean
    }
  },
  data() {
    return {
      // oa审批中状态时，不需要展示删除按钮
      isOaClose: true,
      // 是否关闭oa文字展示
      isOaStartName: false,
      // oa审核状态展示
      oaStateName: '',
      cascaderProps: {
        value: 'statusCode',
        label: 'statusName',
        children: 'customerServiceList'
      },
      cascaderValue: [],
      isCascader: false,
      flg: true,
      showline: false,
      topfonts: '离线',
      user: '',
      // 客服切换状态是否需要OA审批
      isExamineApprove: -1,
      // OA审批弹窗参数
      stateName: '', // 切换状态名称
      ApprovalVisible: false,
      stateKey: '', // 保存状态的key
      oldStateKey: '', // 保存切换之前的key
      messageTotal: 0, // 消息盒子的消息数量
      yunkefu: false,
      showButton: true, //  快捷入口是否展示
      showEmpIndex: false, // 顶部客服个人指标是否展示
      empTarget: {}
    }
  },
  computed: {
    ...mapState({
      arrlist: state => state.work.arrlist,
      index: state => state.work.index,
      topfont: state => state.work.topfont,
      nowlist: state => state.work.nowlist,
      empIds: state => state.work.empIds,
      sessdatas: state => state.sessdatas,
      wsConnetState: state => state.work.wsConnetState,
      startTypeEnum: state => state.work.startTypeEnum,
      setOastate: state => state.work.setOastate
    }),
    setstates() {
      return ['正常', '重连中', '断线'][this.wsConnetState]
    }
  },
  watch: {
    $route(val) {
      if (val.name === '/work') {
        this.showline = true
        this.showEmpIndex = true
        this.showButton = false
        this.getEmpIndex()
      } else {
        this.showline = false
        this.showEmpIndex = false
        this.showButton = true
      }
    },
    empIds(val) {
      if (val) {
        this.setCascaderValue()
      }
    },
    setOastate(val) {
      if (val.passageway === 0) {
        setTimeout(() => {
          this.setdisabled(this.startTypeEnum, false)
        }, 500)
        this.isOaClose = true
        this.oaStateName = val.resultCode === 1 ? `申请${this.stateName}通过` : `申请${this.stateName}不通过`
        if (val.resultCode === 1) {
          if (val.targetStatus > 3) {
            this.cascaderValue = [3, val.targetStatus]
          } else {
            this.cascaderValue = [val.targetStatus]
          }
          const newempdatas = JSON.parse(JSON.stringify(this.empIds))
          newempdatas.statusCode = val.targetStatus
          this.$store.dispatch('work/setempIds', newempdatas)
          if (val.targetStatus === 1) {
            http.allocaTionCustomer({ empId: this.empIds.empId }).subscribe(
              () => {}
            )
            this.$message({
              showClose: 'true',
              message: '上线成功',
              type: 'success'
            })
          }
        }
      } else {
        setTimeout(() => {
          this.setdisabled(this.startTypeEnum, true)
        }, 500)
        this.isOaClose = false
        this.isOaStartName = true
      }
    }
  },
  mounted() {
    if (document.domain === 'customerserviceadmin-do-dev.yunjiglobal.com' // 测试环境
    || document.domain === 'openxinyun.yunjiglobal.com' // 现网
    ) this.yunkefu = true
    this.$nextTick(() => {
      if (this.$route.name === '/work') {
        this.showline = true
      } else {
        this.showline = false
      }
    })
    if (this.$route.name === '/work') {
      this.showEmpIndex = true
      this.showButton = false
      this.getEmpIndex()
    }
  },
  methods: {
    // 关闭oa文字展示
    getOaClose() {
      this.isOaStartName = false
    },
    setCascaderValue() {
      // 根据判断获取完整id
      if (this.empIds.statusCode > 3) {
        this.cascaderValue = [3, this.empIds.statusCode]
      } else {
        this.cascaderValue = [this.empIds.statusCode]
      }
    },
    setflg() {
      this.flg = !this.slideflg
      this.$emit('update:slideflg', this.flg)
    },
    // 打开下拉弹窗
    handleOpen() {
      this.isCascader = true
    },
    // 获取状态下拉框选中的值事件
    handleCascader(key) {
      const that = this
      if (key && key.length) {
        key = key[key.length - 1]
      }

      // const datas = {
      //   empId: this.empIds.empId,
      //   status: key
      // }
      // if (!this.$store.getters['work/wsState'] && key !== 2) {
      //   this.$message({
      //     showClose:'true',
      //     message: "链接已断开，请你重新尝试或者刷新页面",
      //     type: 'error'
      //   })
      //   return
      // }
      // if(key == 1) {
      //   this.setsetatus(datas).then(() => {
      //     this.topfonts = ['','上线','离线','忙碌'][key]
      //     this.$store.dispatch("work/settopfont", '1')
      //   })
      // }else {
      //   this.gotout(datas)
      // }
      this.setdisabled(this.startTypeEnum, true)
      // 保存切换状态的key
      this.stateKey = key
      // 保存切换之前的key
      this.oldStateKey = this.empIds.statusCode
      // 调用切换状态接口之前当前选中的值展示旧的值
      setTimeout(() => {
        if (key > 3) {
          that.cascaderValue = [3, that.empIds.statusCode]
        } else {
          that.cascaderValue = [that.empIds.statusCode]
        }
      }, 500)
      if (this.empIds.statusCode == null) {
        this.empIds.statusCode = 2
      }
      const data = {
        empId: this.empIds.empId,
        switchType: 3,
        currentStatus: this.empIds.statusCode,
        targetStatus: key,
        switchCause: 0
      }
      http.verifyOaCheck(data).subscribe(
        (res) => {
          if (res.data.code === 0) {
            this.$message({ type: 'success', message: '客服切换成功' })
            this.setdisabled(this.startTypeEnum, false)
            const newempdata = JSON.parse(JSON.stringify(this.empIds))
            newempdata.statusCode = key
            this.$store.dispatch('work/setempIds', newempdata)
            this.isOaStartName = false
            if (data.targetStatus === 1) {
              http.allocaTionCustomer({ empId: this.empIds.empId }).subscribe(() => {})
            }
          } else if (res.data.code === 1) {
            this.setdisabled(this.startTypeEnum, false, key)
            this.ApprovalVisible = true
          } else {
            this.$message.error('切换失败')
          }
        },
        () => {
          this.setdisabled(this.startTypeEnum, false)
        }
      )
    },
    // OA审批确认按钮
    approvalSubmit() {
      const data = {
        empId: this.empIds.empId,
        switchType: 3,
        currentStatus: this.oldStateKey,
        targetStatus: this.stateKey,
        switchCause: 0,
        oaCheck: 1
      }
      http.newCustomerStatus(data).subscribe((res) => {
        if (res.data.code === 0) {
          this.setdisabled(this.startTypeEnum, false)
          const newempdata = JSON.parse(JSON.stringify(this.empIds))
          newempdata.statusCode = this.stateKey
          this.$store.dispatch('work/setempIds', newempdata)
          // 当需要oa审批时，展示审批中的文案
          this.isOaClose = true
          this.isOaStartName = true
          this.oaStateName = `申请${this.stateName}通过`
          http.allocaTionCustomer({ empId: this.empIds.empId }).subscribe(() => {})
          this.$message({
            showClose: 'true',
            message: '上线成功',
            type: 'success'
          })
        } else if (res.data.code === 3) {
          this.isOaClose = false
          this.isOaStartName = true
          this.oaStateName = `申请${this.stateName}中`
          if (this.oldStateKey > 3) {
            this.cascaderValue = [3, this.oldStateKey]
          } else {
            this.cascaderValue = [this.oldStateKey]
          }
          this.setdisabled(this.startTypeEnum, true)
        } else if (res.data.code === 2 || res.data.code === 1) {
          this.isOaClose = true
          this.isOaStartName = true
          this.oaStateName = `申请${this.stateName}不通过`
          this.setdisabled(this.startTypeEnum, false)
        } else if (res.data.code === null) {
          this.$message({ type: 'success', message: '客服切换异常，请重新点击切换' })
        }
        this.ApprovalVisible = false
      })
    },
    // OA审批取消按钮
    approvalCancel() {
      this.ApprovalVisible = false
      if (this.oldStateKey > 3) {
        this.cascaderValue = [3, this.oldStateKey]
      } else {
        this.cascaderValue = [this.oldStateKey]
      }
      this.setdisabled(this.startTypeEnum, false)
    },
    setsetatus(datas) {
      return new Promise((resq, reqs) => {
        http.getTopstatus(datas, { errorMsg: 'none' }).subscribe(
          (res) => {
            resq(res)
            if (res.response.data.errorCode === 0) {
              const newemps = JSON.parse(JSON.stringify(this.empIds))
              newemps.empImg = res.data.headImgSrc
              this.$store.dispatch('work/setempIds', newemps)
              http.allocaTionCustomer({ empId: this.empIds.empId }).subscribe(
                () => {}
              )
              this.$message({
                showClose: 'true',
                message: '上线成功',
                type: 'success'
              })
            } else {
              // this.$message({
              //   showClose:'true',
              //   message: res.errorMessage,
              //   type: 'error'
              // })
            }
          },
          (error) => {
            reqs(error)
            this.$message({
              showClose: 'true',
              message: error.responseText,
              type: 'error'
            })
          }
        )
      })
    },
    gotout(datas) {
      http.getTopstatus(datas, { errorMsg: 'none' }).subscribe(
        (res) => {
          this.topfonts = ['', '上线', '离线', '忙碌'][datas.status]
          this.$store.dispatch('work/settopfont', datas.status)
          if (res.response.data.errorCode === 0) {
            this.$message({
              showClose: 'true',
              message: res.response.data.errorMessage,
              type: 'success'
            })
          }
        }
      )
    },
    getwork() {
      this.$router.push({ name: '/work' })
    },
    getPassWord() {
      this.$router.push({ path: '/login/resetPassword' })
    },
    reload() {
      window.location.reload()
    },
    setdisabled(data, state, code) {
      if (!code) code = 999
      // 根据遍历禁用所有状态
      for (let i = 0; i < data.length; i += 1) {
        if (data[i].customerServiceList == null) {
          data[i].disabled = state
          if (data[i].statusCode === 9) {
            data[i].disabled = true
          }
        } else if (data[i].customerServiceList && data[i].customerServiceList.length > 0) {
          this.setdisabled(data[i].customerServiceList, state, code)
        }
        if (data[i].statusCode === code) {
          this.stateName = data[i].statusName
        }
      }
    },
    getEmpIndex() {
      http.getEmpIndex().subscribe(
        (res) => {
          this.empTarget = res.data || {}
          setTimeout(() => {
            this.getEmpIndex()
          }, 30000)
        },
        () => {
          setTimeout(() => {
            this.getEmpIndex()
          }, 15000)
        }
      )
    }
  }
}
</script>
<style lang="less">
@import '~styles/var.less';
#totop {
  background: #ffffff;
  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.08);
  height: 59px;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.oa_state {
  padding-right: 28px;
  color: red;
  .el-icon-circle-close {
    padding: 0 0 0 4px;
    cursor: pointer;
  }
}
.totop_left {
  label {
    cursor: pointer;
  }
  img {
    display: block;
    width: 16px;
    height: 16px;
    margin: 0 26px 0 20px;
    float: left;
  }
  span {
    font-size: 12px;
    color: #333;
    display: inline-block;
    line-height: 16px;
  }
}
.totop_mid {
  position: absolute;
  left: 230px;
  &::before {
    content: ' ';
    width: 1px;
    height: 30px;
    background-color: #ccc;
    position: absolute;
    left: -20px;
    top: 5px;
  }
}
.totop_right {
  padding: 0 20px 0 0;
  .totop_menus {
    cursor: pointer;
    display: inline-block;
    padding: 0 28px 0 0;
    /deep/ .el-badge {
      vertical-align: baseline;
    }
    .el-dropdown{
      // vertical-align: middle;
      margin-right: 20px;
    }
    .message-badge{
      font-size: 12px;
      outline: none;
    }
  }
  #panelProp {
    .el-cascader {
      .el-input .el-input__inner {
        width: 100px;
        color: #000;
        border: none;
        text-align: center;
        font-size: 12px;
      }
    }
  }
}
.totop-message-class {
  padding: 12px!important;
  width: 600px!important;
}
</style>
